import * as React from 'react';
import { useStyles } from './styles';
import Box from '@mui/material/Box';
import { useEffect } from 'react';
import { UnregisterTouchToMouse } from '@core/dashboard/components/DashboardContent/GameCast/touchtomouse';

const VideoGamecast = () => {
  const classes = useStyles();
  const videoRef = React.useRef<HTMLVideoElement>(null);

  useEffect(() => {
    return () => {
      const videoElement = document.getElementById('gamecastVideoTag');

      if (videoElement) {
        UnregisterTouchToMouse(videoElement)
      }
    }
  }, []);

  return (
    <Box sx={classes.root}>
      <video
        ref={videoRef}
        playsInline
        autoPlay
        id="gamecastVideoTag"
        muted
        onContextMenu={(event) => {
          event.preventDefault();
          return false;
        }}
        onPause={() => videoRef.current?.play()}
      ></video>
      <audio autoPlay muted id="gamecastAudioTag" />
    </Box>
  );
};

export default VideoGamecast;
